import { render } from "./CountdownButton.vue?vue&type=template&id=476ca6c6"
import script from "./CountdownButton.vue?vue&type=script&lang=js"
export * from "./CountdownButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__